module.exports = __webpack_public_path__ + "img/erweima.a3c576a5.png";